import { Component, ViewChildren, ComponentRef, OnInit, Input, ViewChild, TemplateRef, NgZone } from '@angular/core';
import { LoginSignupComponent } from '../shared/login-signup/login-signup.component';
import { ShakeAnimationService } from 'src/app/services/shake-animation/shake-animation.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { VerificationContractService } from 'src/app/services/Auth/verification-contract.service';
//import { FacebookPixelService } from 'src/app/services/Facebook-pixel/facebook-pixel.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
declare var google:any;
@Component({
  selector: 'ipm-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
  @Input() dialogType: any = '';
  currentDialogType: any = 'login';
  @ViewChildren(LoginSignupComponent) loginComponent: ComponentRef<any>;
  @ViewChild('forgotPasswordTemplate', { static: false })
  forgotPasswordTemplate: TemplateRef<any>;
  @ViewChild('producerJoinTemplate', { static: false })
  producerJoinTemplate: TemplateRef<any>;
  @ViewChild('producerConfirmationTemplate', { static: false })
  producerConfirmationTemplate: TemplateRef<any>;
  @ViewChild('otpTemplate', { static: false }) otpTemplate: TemplateRef<any>;
  @ViewChild('notifyPopup', { static: false }) notifyPopup: TemplateRef<any>;
  @ViewChild('onboardingFlowTemplate', { static: false }) onboardingFlowTemplate: TemplateRef<any>;
  @ViewChild('sellerConfirmationTemplate', { static: false }) sellerConfirmationTemplate: TemplateRef<any>;
  authDialogType: string = 'login';
  imgUrl: string = environment.imageUrl;
  isStartSelling: boolean = false;
  isOtpMode: boolean = false;
  isGoogleBtnRenderedLogin: boolean = false;
  isGoogleBtnRenderedSignup: boolean = false;
  mainLogoName: string = './assets/imgs/beat22-logo/main-logo-beat22.svg';
  constructor(
    public shakeAnimation: ShakeAnimationService,
    public commonService: CommonService,
    private router: Router,
    private authService: AuthService,
    private routerActivated: ActivatedRoute,
    private ngZone: NgZone,
    public browserService: BrowserStorageService,
    private verificationContract: VerificationContractService,
    //public fbPixel: FacebookPixelService,
    public ga4Tracking: Ga4trackingService
  ) {}

  ngOnInit(): void {
    this.authService.googleLoginEventListener().subscribe((token) => {
      if (token) {
        this.loginRegisterWithSocialApp('google', token);
      }
    });
    this.routerActivated.data.subscribe((data: any) => {
      this.currentDialogType = data['title'] === 'Sign in' ? 'login' : 'signup';
      this.commonService.setTitleService(data['title'], data['description']);
      this.authDialogType = this.currentDialogType;
      this.isOtpMode = false;
      setTimeout(() => {
        this.googleButtonClick();
      }, 100);
    });

    this.routerActivated.queryParamMap.subscribe((params: Params) => {
      if (params['params'].startSelling) {
        this.isStartSelling = true;
      } else {
        this.isStartSelling = false;
      }
    });
  }

  googleButtonClick() {
    let loginButtonType = this.authDialogType === 'login' ? 'signin_with' : 'signup_with';
    const divId = this.authDialogType === 'login' ? 'googleBtnDivLogin' : 'googleBtnDivSignup';
      
    if (this.authDialogType === 'login' && this.isGoogleBtnRenderedLogin) return;
    if (this.authDialogType === 'signup' && this.isGoogleBtnRenderedSignup) return;

    const btnDiv = document.getElementById(divId);
    if (!btnDiv) return;

    // @ts-ignore
    google.accounts.id.initialize({
      // Ref: https://developers.google.com/identity/gsi/web/reference/js-reference#IdConfiguration
      client_id:
        '953003447892-28rrv8p70df966mhcq1aaqsmriqghorh.apps.googleusercontent.com',
      callback: (data: any) => {
        this.ngZone.run(() => {
          this.authService.emitGoogleLoginEvent(data.credential);
        });
      },
      cancel_on_tap_outside: false,
    });
    
    google.accounts.id.renderButton(
      btnDiv,
      { theme: 'outline', size: 'medium', text: loginButtonType }
    );
    
    if (this.authDialogType === 'login') this.isGoogleBtnRenderedLogin = true;
    if (this.authDialogType === 'signup') this.isGoogleBtnRenderedSignup = true;
  }

  /**
   * When Change  toggle ButtonClear data when change  toggle
   */
  clearError() {
    this.shakeAnimation.removeClass(this.geAuthClassName());
  }

  onChangesLogin($event: any) {
    let path: string = $event === 'signup' ? '/signup' : '/signin';
    let params: any = {};
    if (this.isStartSelling) {
      params = { startSelling: true };
    }
    this.router.navigate([path], { queryParams: params });
    this.clearError();
    let currentEvent: any =
      this.currentDialogType === 'login' ? 'login_event' : 'signup_event';
    let button: string =
      this.currentDialogType === 'login' ? 'login_method' : 'signup_method';
    let attributes: any = {
      category: currentEvent,
      label: button,
      action: currentEvent,
      linkDestination: '',
      userRole: this.browserService?.getCurrentRoles() || 'guest',
      userId: this.browserService?.getUserId() || 'guest',
    };
    // this.ga4Tracking.ga4Custom(currentEvent, attributes)
    this.ga4Tracking.sendEvent(currentEvent, attributes);
  }

  /**
   * Return auth class Name
   * @returns
   */
  geAuthClassName() {
    let className = this.commonService.isMobileDisableClick
      ? 'mobile-view-auth-model'
      : 'auth-model';
    return className;
  }

  /**
   * open Forgot Model
   */
  openForgotChanges() {
    this.closeByDeviceType();
    let className = this.commonService.getClassName('ipm-forgot-model');
    this.commonService.openModel(this.forgotPasswordTemplate, '', className);
    this.closingActionPerform('forgotPassword');
  }

  /**
   * Close Model According to its Types
   */
  closeByDeviceType() {
    if (this.commonService.isMobileDisableClick) {
      if (this.commonService.bottomRef) {
        this.commonService.bottomRef.dismiss();
      }
    } else {
      if (this.commonService.modelRef) {
        this.commonService.modelRef.close();
      }
    }
  }

  /**
   * close model by according to its type
   * @param callingType
   */
  closingActionPerform(callingType: any) {
    if (!this.commonService.isMobileDisableClick) {
      this.commonService.modelRef.afterClosed().subscribe((res) => {
        this.closeMethodCheck(res, callingType);
      });
    } else {
      this.commonService.bottomRef.afterDismissed().subscribe((res) => {
        this.closeMethodCheck(res, callingType);
      });
    }
  }

  /**
   * after close model action trigger
   * @param res
   * @param callingType
   * @returns
   */
  closeMethodCheck(res: any, callingType: any) {
    if (callingType === 'producerJoin') {
      this.redirectAfterAuth(res?.data?.user?.role);
    } else if (callingType === 'forgotPassword') {
      if (res) {
        let sendData = {
          popUpType: 'reset-password',
          message: `
          <div>
            <p>Password reset link is sent into this mail <b><q>${res}</q></b> please check your mail inbox</p>
          </div>
        `,
        };
        let classNotifyName = this.commonService.getClassName(
          'ipm-notify-popup-model'
        );
        this.commonService.openModel(
          this.notifyPopup,
          sendData,
          classNotifyName,
          true
        );
      }
    } else if (callingType === 'OtpModel') {
      if (res) {
        if (res === 'signup') {
          if (this.isStartSelling) {
            this.openSellerOnboardingFlow();
          } else {
            this.openUserSelected();
          }
        } else if (res === 'signin') {
          this.redirectAfterAuth();
        } else {
          this.redirectAfterAuth();
        }
      }
    } else {
      if (res) {
        if (res === 'producer') {
          this.openSellerOnboardingFlow();
          return;
        } else {
          this.redirectAfterAuth();
        }
      }
    }
  }

  /**
   * Open onboarding flow for seller.
   * Gates through SellerConfirmationPopup — onboarding only starts when user agrees.
   */
  openSellerOnboardingFlow() {
    // Step 1: show seller agreement confirmation popup
    const className = this.commonService.getClassName('ipm-seller-confirmation-model');
    this.commonService.openModel(this.sellerConfirmationTemplate, {}, className, true);

    // Step 2: only open onboarding when user accepted
    if (!this.commonService.isMobileDisableClick) {
      this.commonService.modelRef.afterClosed().subscribe((res: string) => {
        if (res === 'agreed') {
          this.openOnboardingFlowDialog();
        }
      });
    } else {
      this.commonService.bottomRef.afterDismissed().subscribe((res: string) => {
        if (res === 'agreed') {
          this.openOnboardingFlowDialog();
        }
      });
    }
  }

  /**
   * Open the onboarding flow modal and set onboarding seen after completion.
   */
  private openOnboardingFlowDialog() {
    const className = this.commonService.getClassName('onboarding-flow-model');
    this.commonService.openModel(
      this.onboardingFlowTemplate,
      { userRole: 'producer' },
      className,
      true
    );
    if (!this.commonService.isMobileDisableClick) {
      this.commonService.modelRef.afterClosed().subscribe(() => {
        this.authService.setOnboardingSeen().subscribe(() => {
          this.redirectAfterAuth('producer');
        });
      });
    } else {
      this.commonService.bottomRef.afterDismissed().subscribe(() => {
        this.authService.setOnboardingSeen().subscribe(() => {
          this.redirectAfterAuth('producer');
        });
      });
    }
  }

  /**
   * Redirect after successful authentication
   * @param userRole - optional user role
   */
  private redirectAfterAuth(userRole?: string) {
    const role = userRole || this.browserService.getCurrentRoles();
    const previousRoute = this.browserService.getPreviousRoute();

    if (previousRoute && !this.browserService.isBaseRoute(previousRoute)) {
      // Clear the previous route and redirect
      this.browserService.clearPreviousRoute();
      this.router.navigate([previousRoute]).then(() => {
        // Small delay to ensure navigation completes before reload
        setTimeout(() => {
          location.reload();
        }, 100);
      });;
    } else {
      // Redirect to appropriate dashboard based on role
      const dashboardRoute = this.browserService.getDashboardRoute(role);
      this.router.navigate([dashboardRoute]).then(() => {
        // Small delay to ensure navigation completes before reload
        setTimeout(() => {
          location.reload();
        }, 100);
      });
    }

    this.closeByDeviceType();
  }

  /**
   * open producer model
   */
  openProducerJoinPop() {
    let className = this.commonService.getClassName('ipm-producer-form-model');
    this.commonService.openModel(
      this.producerJoinTemplate,
      '',
      className,
      true
    );
    this.closingActionPerform('producerJoin');
  }

  /**
   * open user selected model
   */
  openUserSelected() {
    this.closeByDeviceType();
    let className = this.commonService.getClassName('ipm-producer-model');
    this.commonService.openModel(this.producerConfirmationTemplate,'',className,true);
    this.closingActionPerform('producerConfirmation');
  }

  /**
   * User Login
   * @param formData
   */
  authLogin(formData: FormGroup) {
    this.clearError();
    const data = formData.value;
    let evevntName = 'sign_in_initiated';
    let attributes: any = {
      category: 'login_event',
      label: 'login_method',
      action: 'login_event',

      userRole: this.browserService?.getCurrentRoles() || 'guest',
      userId: this.browserService?.getUserId() || 'guest',
    };
    // this.ga4Tracking.sendEvent(evevntName, attributes);
    this.authService.userLogin(data).subscribe(
      (res) => {
        this.checkDataWhileLoginIn(res);
      },
      (error) => {
        if (this.verificationContract.isEmailSigninVerificationGate(error)) {
          const emailGateUserData =
            this.verificationContract.getEmailSigninGateData(error);
          this.sendOtp(emailGateUserData || error?.error?.data, 'signin', data?.email);
          return;
        }
        this.shakeAnimation.errorMessage =
          this.verificationContract.extractErrorMessage(error);
      }
    );
  }

  /**
   * Passwordless login with email OTP
   * @param formData
   */
  authLoginWithOtp(formData: FormGroup) {
    this.clearError();
    const emailControl = formData.get('email');
    emailControl?.markAsTouched();
    if (!emailControl || emailControl.invalid) {
      return;
    }

    const email = (emailControl.value || '').toString().trim();
    this.authService.signInWithOtp(email).subscribe(
      (res) => {
        this.sendOtp(res, 'signin', email);
      },
      (error) => {
        this.shakeAnimation.errorMessage =
          this.verificationContract.extractErrorMessage(error);
      }
    );
  }

  /**
   * user Register function
   * @param formData
   */
  authSignup(formData: FormGroup) {
    this.clearError();
    const password = formData.value.password;
    const passwordConfirm = formData.value.confirmPassword || password;
    const data = {
      email: formData.value.email,
      password: password,
      passwordConfirm: passwordConfirm,
      password_confirm: passwordConfirm,
      name: '',
      role: 'customer'
    };
    let evevntName = 'sign_up_initiated';
    let attributes: any = {
      category: 'signup_event',
      label: 'signup_method',
      action: 'signup_event',
      userRole: 'guest',
    };
    // this.ga4Tracking.sendEvent(evevntName, attributes);
    this.authService.userRegister(data).subscribe(
      (res) => {
        this.sendOtp(res, 'signup', data.email);
        // this.fbPixel.trackEvent('signup');
      },
      (error) => {
        this.shakeAnimation.errorMessage =
          this.verificationContract.extractErrorMessage(error);
      }
    );
  }

  /**
   * Open email OTP flow with normalized user payload
   * @param sendData
   * @param callingFrom
   */
  sendOtp(sendData: any, callingFrom: any, fallbackEmail: string = '') {
    const responseData = sendData?.data ? sendData.data : sendData;
    const userData =
      responseData?.user && Object.keys(responseData.user).length
        ? responseData.user
        : responseData;
    const userId = userData?._id || responseData?._id;
    const userEmail = userData?.email || responseData?.email || fallbackEmail;
    if (!userId) {
      this.shakeAnimation.errorMessage = 'Unable to start verification. Please try signing in again.';
      return;
    }
    const otpPayload: any = {
      ...userData,
      _id: userId,
      callingForm: callingFrom,
    };
    if (userEmail) {
      otpPayload.email = userEmail;
    }
    this.closeByDeviceType();
    this.openOtpModel(otpPayload);
  }

  /**
   * open otp pop function
   * @param sendData
   */
  openOtpModel(sendData: string = '') {
    let className = this.commonService.getClassName('ipm-otp-model');
    this.commonService.openModel(this.otpTemplate, sendData, className, true);
    this.closingActionPerform('OtpModel');
  }

  /**
   * Login or Register with social media app
   */
  loginRegisterWithSocialApp(type: string, token: any) {
    this.authService.signInWithSocial(type, token).subscribe(
      (res) => {
        this.checkDataWhileLoginIn(res);
      },
      (error) => {
        this.shakeAnimation.addShakeAnimation(this.geAuthClassName());
        this.shakeAnimation.errorMessage = error.error.message;
      }
    );
  }

  checkDataWhileLoginIn(res: any) {
    if (res?.status === 'fail') {
      if (res.data && res.data.is_email_verified === false) {
        this.sendOtp(res, 'signin');
      } else {
        this.shakeAnimation.errorMessage = res.message || 'Authentication failed.';
        this.shakeAnimation.addShakeAnimation(this.geAuthClassName());
      }
      return;
    }

    let data = res?.data;
    if (data && Object.keys(data).length > 0) {
      if (data.user && !data.user.is_email_verified) {
       this.sendOtp(res,'signin');
      } else {
        // Use the enhanced redirect logic
        this.redirectAfterAuth(res?.data?.user?.role);
        
        let currentEvent : any = this.currentDialogType === "login" ? "sign_in_completed": "sign_up_completed";
        let button : string = this.currentDialogType === "login" ? "login_method": "signup_method";
        let attributes: any = {
          category: currentEvent,
          label: button,
          action: currentEvent,
          userRole: this.browserService?.getCurrentRoles() || 'guest',
          userId : this.browserService?.getUserId() || 'guest'
        }
        this.ga4Tracking.sendEvent(currentEvent, attributes);
      }
    }
  }
}
